import '~/entrypoints/config/init';
import { createApp, h } from 'vue';
import HubApp from '~/plugins/hub_app';
import SuggestedMergesBanner from '~/components/merge_members/SuggestedMergesBanner.vue';

function mount() {
  document.querySelectorAll('[data-vue="merge_members_banner"]').forEach((el) => {
    const orgId = Number(el.dataset.organizationId);
    const initialCount = Number(el.dataset.initialCount);
    const initialIds = (el.dataset.ids || '').split(',').filter(Boolean).map(Number);

    const app = createApp({
      render: () =>
        h(SuggestedMergesBanner, {
          organizationId: orgId,
          initialCount,
          initialIds,
        }),
    });

    app.use(HubApp);
    app.mount(el);
  });
}

document.addEventListener('DOMContentLoaded', mount);
